import { Hint } from '@routable/components';
import { Time } from '@carbon/icons-react';
import React from 'react';
export const RiskChecksInProgressHint = ({ taxFormType }) => (React.createElement(Hint, { icon: React.createElement(Time, null), title: `${taxFormType} was submitted and validation is in progress`, type: "info", variant: "outline" }));
